// extracted by mini-css-extract-plugin
export default {"page":"LegalPage_page__71MUj","document":"LegalPage_document__Kc7ob","homeLink":"LegalPage_homeLink__w6nat","revision":"LegalPage_revision__6A6MB"};